import moment from "moment";
export class StaffEmployment {
  StaffID;
  DateJoin;
  DateProbatEnd;
  JobCode;
  SACode;
  StaffEmployment;
  Title;
  Salary;
  EmpType;
  StaffGrade;
  EmpStatus;
  Dept;
  TeamCode;
  Supervisor;
  DateTerm;
  DateLastWork;
  CalMethod;
  SinceDate;
  AddBy;
  ModifyBy;
  JobName;
  DateResign;
  ShiftCode;
  ShiftCodeSat;
  ShiftCodeSun;
  HolidayType;
  constructor() {
    this.StaffID = "";
    this.DateJoin = "";
    this.DateProbatEnd = moment().format("YYYY-MM-DD");
    this.JobCode = "";
    this.SACode = "";
    this.StaffEmployment = "";
    this.Title = "";
    this.Salary = null;
    this.EmpType = "";
    this.StaffGrade = "";
    this.EmpStatus = "";
    this.Dept = "";
    this.TeamCode = "";
    this.Supervisor = "";
    this.DateTerm = "";
    this.DateLastWork = "";
    this.CalMethod="";
    this.SinceDate = moment().format("YYYY-MM-DD");
    this.AddBy = "";
    this.ModifyBy = "";
    this.JobName = "";
    this.DateResign = "";
    this.ShiftCode = "";
    this.ShiftCodeSat = "";
    this.ShiftCodeSun = "";
    this.HolidayType = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/StaffEmployment.js